import React from 'react';
import type { FeedFilter } from 'types/interfaces/feed';
import { FILTER_OPTIONS } from '../constants';
import './FeedFilterBar.css';

interface FeedFilterBarProps {
  filter: FeedFilter;
  onFilterChange: (filter: FeedFilter) => void;
  cardSearch: string;
  onCardSearchChange: (value: string) => void;
  isPaused: boolean;
  onTogglePause: () => void;
  pendingCount: number;
}

export const FeedFilterBar: React.FC<FeedFilterBarProps> = ({
  filter,
  onFilterChange,
  cardSearch,
  onCardSearchChange,
  isPaused,
  onTogglePause,
  pendingCount,
}) => {
  return (
    <div className="feed-filter-bar">
      <div className="feed-filter-bar__pills" role="tablist">
        {FILTER_OPTIONS.map((opt) => {
          const active = opt.value === filter;
          return (
            <button
              key={opt.value}
              type="button"
              role="tab"
              aria-selected={active}
              className={`feed-filter-pill ${active ? 'feed-filter-pill--active' : ''}`}
              onClick={() => onFilterChange(opt.value)}
            >
              {opt.label}
            </button>
          );
        })}
      </div>

      <input
        type="text"
        className="feed-filter-bar__search"
        placeholder="Search by card name..."
        value={cardSearch}
        onChange={(e) => onCardSearchChange(e.target.value)}
        aria-label="Search by card name"
      />

      <button
        type="button"
        className={`feed-filter-bar__pause ${isPaused ? 'feed-filter-bar__pause--paused' : ''}`}
        onClick={onTogglePause}
        aria-pressed={isPaused}
      >
        {isPaused ? 'Resume' : 'Pause'}
        {isPaused && pendingCount > 0 && (
          <span className="feed-filter-bar__pause-badge">{pendingCount}</span>
        )}
      </button>
    </div>
  );
};

export default FeedFilterBar;
